<template>
  <div class="feedback-wrapper" ref="feedbackWrapper" @mousedown="move">
    <ul>
      <li>
        <form method="post" target="_blank" :action="'https://support.qq.com/product/380406'">
          <input type="hidden"  name="openid" :value="userinfo.id">
          <input type="hidden"  name="nickname" :value="userinfo.realName">
          <input type="hidden"  name="avatar" :value="userinfo.thumbAvatar">
          <input type="hidden"  name="clientInfo" :value="getUserAgent">
          <input type="hidden"  name="clientVersion" :value="us.browserVersion">
          <input type="hidden"  name="os" :value="us.os">
          <input type="hidden"  name="osVersion" :value="us.osVersion">
          <input type="hidden"  name="customInfo" :value="getDomain">
          <el-tooltip class="item" effect="dark" content="点击可以进行意见反馈哦" placement="left">
            <button :type='buttonType' class="btn-feedback" ><yun-icon name="icon-drxx54" @mousedown.stop="()=>{}"/></button>
          </el-tooltip>
      </form>
      </li>
      <li>
        <div class="icon-wrapper">
          <img src="./ewm.png" width="129" height="129" alt="微信扫码在线沟通">
          <p class="img-p">微信扫码在线沟通</p>
        </div>
        <yun-icon name="icon-kefu" />
      </li>
    </ul>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ua from './ua';
export default {
  name: 'Feedback',
  props: {},
  computed: {
    ...mapGetters([
      'userinfo'
    ]),
    getDomain(){
      return document.location.origin
    },
    getUserAgent(){
      return navigator.userAgent
    }
  },
  data() {
    return {
      // 防止 拖动完 自动提交form表单
      buttonType: 'submit',
      // 获取浏览器版信息
      us: ua()
    }
  },
  mounted() {
  },
  methods: {
    move(e){
      // let odiv = e.target;
      let odiv = this.$refs.feedbackWrapper;        //获取目标元素
      const bdWidth = document.body.offsetWidth; // body Width
      const bdHeight = document.body.offsetHeight; // body Height
      const oWidth = odiv.offsetWidth; //目标元素 Width
      const oHeight = odiv.offsetHeight; //目标元素 Height

      const bleft = bdWidth - oWidth // body left 距离
      const btop = bdHeight - oHeight // body top 距离
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e)=>{       //鼠标按下并移动的事件
          this.buttonType = 'button'
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;  
          let top = e.clientY - disY;
          
          //绑定元素位置到positionX和positionY上面
          this.positionX = top;
          this.positionY = left;
          
          //移动当前元素
          if(left >= bleft){
            odiv.style.left = bleft + 'px';
          }else if(left <= 0){
            odiv.style.left = '0px';
          }else{
            odiv.style.left = left + 'px';
          }
          if(top >= btop){
            odiv.style.top = btop + 'px';
          }else if(top <= 0){
            odiv.style.top = '0px';
          }else{
            odiv.style.top = top + 'px';
          }
          odiv.style.bottom = 'auto';
          odiv.style.right = 'auto';
      };

      // 鼠标抬起事件
      document.onmouseup = (e) => {
          setTimeout(()=>{
            this.buttonType = 'submit'
          },300)
          
          document.onmousemove = null;
          document.onmouseup = null;
      };
    }
  }
}
</script>
<style lang="scss" scoped>
.feedback-wrapper{
  position: fixed;
  right: 0;
  bottom: 80px;
  background: #FFF;
  box-shadow: -1px 0 12px 0 rgba(0, 0, 0, 0.3);
  z-index: 3001;
  border-radius: 3px;
  
  .btn-feedback{
    width: 100%;
    height: 100%;
    background: #FFF;
    color: #707070;
    border: 0;
    font-size: 18px;
    cursor: pointer;
    
    >.mousedown{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      cursor: all-scroll;
    }
  }
  .btn-feedback:active{
    border: 0;
  }
  >ul{
    padding: 0;
    margin: 0;
    >li{
      position: relative;
      &:after{
        content: " ";
        position: absolute;
        bottom: 0;
        left: 5px;
        right: 5px;
        height: 1px;
        border-top: 1px solid #D5D5D5;
      }
      &:last-child{
        &:after{
          border: 0;
        }
      }
      &:hover{
        color: var(--geek-color-primary);
        .btn-feedback{
          color: var(--geek-color-primary);
        }
        .icon-wrapper{
          display: block;
        }
      }
      >span{
        display: block;
        width: 100%;
        height: 100%;
      }
      .icon-wrapper{
        &:after{
          content: "";
          position: absolute;
          bottom: 10px;
          right: -12px;
          border-width: 6px;
          display: block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-top-color: #FFF;
          transform: rotate(-90deg);
        }
        display: none;
        padding: 5px;
        position: absolute;
        left: -145px;
        bottom: -1px;
        background-color: #FFf;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-sizing: border-box;
        >img{
          margin-bottom: -10px;
        }
        .img-p{
          margin: 0;
          color: var(--geek-color-primary);
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          line-height: 25px;
          margin-bottom: 2px;
        }
      }
      position: relative;
      width: 40px;
      height: 40px;
      line-height: 40px;
      list-style: none;
      cursor: pointer;
      text-align: center;
      font-size: 18px;
      color: #707070;
      form{
        width: 100%;
        height: 100%;
      }
    }
  }
  
}
  
</style>
